import {
  ActionIcon,
  Box,
  Button,
  Group,
  Loader,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { id_util, tu } from "beitary-shared";
import { useDBServices } from "hooks/useDBService/useDBService";
import HTMLReactParser from "html-react-parser";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommunicationHistoryCard } from "../CommunicationHistoryCard";

type EmailCommunicationHistoryTableItem = {
  id: string;
  state: string;
  title: string;
  message: string;
  timeString: string;
  error?: string;
  to: string[];
  attachments?: { filename?: string; path?: string }[];
};

export interface EmailCommunicationHistoryTableProps {
  clientId?: string;
  clientName?: string;
  patientId?: string;
  patientName?: string;
}

// started chatgpt opt
export const EmailCommunicationHistoryTable = ({
  clientId,
  patientId,
  clientName,
  patientName,
}: EmailCommunicationHistoryTableProps) => {
  const { t } = useTranslation();

  const [startAfterId, setStartAfterId] = useState<string | undefined>(
    undefined
  );
  const [startBeforeId, setStartBeforeId] = useState<string | undefined>(
    undefined
  );

  const { getEmailCommunicationHistory, getCommunicationHistoryTime } =
    useDBServices().clientCommunication.communicationHistory;

  const [communicationHistorys, setCommunicationHistorys] = useState<
    undefined | null | EmailCommunicationHistoryTableItem[]
  >(undefined);

  const [refreshing, setRefreshing] = useState<boolean>(false);

  const [refresh, setRefresh] = useState(id_util.newId36());

  const handleNextPage = () => {
    fetchCommunicationHistory({ startAfterId });
  };

  const handlePreviousPage = () => {
    fetchCommunicationHistory({ startBeforeId });
  };

  interface fetchCommunicationHistoryProps {
    startAfterId?: string;
    startBeforeId?: string;
    startAtId?: string;
  }
  const fetchCommunicationHistory = useCallback(
    async ({
      startAfterId,
      startBeforeId,
      startAtId,
    }: fetchCommunicationHistoryProps) => {
      setRefreshing(true);
      const props = {
        startAfterId,
        startBeforeId,
        startAtId,
        clientId,
        patientId,
      };
      const result = await getEmailCommunicationHistory(props);

      console.log(result);

      setRefreshing(false);
      // ... handle pagination ...
      if (result.payload && result.payload.length > 0) {
        setCommunicationHistorys(
          result.payload.map((i) => ({
            title: i.message?.subject ?? "",
            error: i.delivery?.error ?? undefined,
            to: i.to,
            id: i.id,
            message: i.message?.html ?? "",
            state: i.delivery?.state ?? "",
            timeString: tu.getDateAndTimeString(getCommunicationHistoryTime(i)),
            attachments: i.message?.attachments,
          }))
        );
        const afterId = result.payload[result.payload.length - 1].id;
        const beforeId = result.payload[0].id;

        setStartAfterId(afterId);
        setStartBeforeId(beforeId);
      } else {
        // // No more data to fetch
        if (startAfterId) setStartAfterId(undefined);
        if (startBeforeId) setStartBeforeId(undefined);
      }
    },
    [
      clientId,
      patientId,
      getEmailCommunicationHistory,
      getCommunicationHistoryTime,
    ]
  );

  useEffect(() => {
    fetchCommunicationHistory({});
  }, [fetchCommunicationHistory, refresh]);

  const cards = useMemo(
    () =>
      (communicationHistorys ?? []).map((a) => {
        const {
          id,
          message,
          state,
          timeString: time,
          to,
          error,
          title,
          attachments,
        } = a;
        return (
          <CommunicationHistoryCard
            key={id}
            title={title}
            content={HTMLReactParser(message)}
            state={
              state === "SUCCESS"
                ? "SUCCESS"
                : state === "ERROR"
                ? "ERROR"
                : "OTHER"
            }
            timestring={time}
            to={to}
            error={error}
            attachments={attachments}
          />
        );
      }),
    [communicationHistorys]
  );
  console.log(communicationHistorys);

  return communicationHistorys === null ? (
    <Text>{t("ERROR")}</Text>
  ) : (
    <Stack>
      <Group position="apart">
        <Box></Box>
        <Group>
          <ActionIcon
            onClick={() => {
              setRefresh(id_util.newId36());
            }}
          >
            {refreshing ? <Loader size="xs" /> : <IconRefresh size={18} />}
          </ActionIcon>
        </Group>
      </Group>
      <Box p="xl">
        <ScrollArea>
          {/* <Table>
            <thead>
              <tr>
                <th>{t("NAME")}</th>
                <th>{t("PATIENT_NAME")}</th>
                <th>{t("DUE_DATE")}</th>
                <th>{t("STATUS")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table> */}
          <Stack>{cards}</Stack>
        </ScrollArea>
        <Group position="right" mt="xl">
          <Button onClick={handlePreviousPage} disabled={!startBeforeId}>
            {t("PREVIOUS")}
          </Button>
          <Button onClick={handleNextPage} disabled={!startAfterId}>
            {t("NEXT")}
          </Button>
        </Group>
      </Box>
    </Stack>
  );
};
